
export default {
  print: {
    print: 'Stampare',
    segment: 'Segmento',
    preparingPrinting: 'Preparazione della stampa',
    readyToPrint: 'Pronta per stampare'
  }
}
